// extracted by mini-css-extract-plugin
export default {"modalContent":"_1ymKtun7","modalText":"gbT77oWC","modalActions":"UoNfgxsM"};